var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body overflow-visible" },
    [
      _vm.isBusy || (_vm.items && _vm.items.length > 0)
        ? [
            _c(
              "div",
              { staticClass: "page-table-container overflow-visible" },
              [
                _c("b-table", {
                  ref: "worker-costs",
                  staticClass: "custom-table mb-0",
                  attrs: {
                    id: "worker-costs",
                    busy: _vm.isBusy,
                    items: _vm.items,
                    fields: _vm.fields,
                    "per-page": _vm.perPage,
                    "current-page": _vm.currentPage,
                    "sort-by": _vm.sortBy,
                    "sort-desc": _vm.sortDesc,
                    "sort-compare": _vm.sortPeriodCompare,
                    "no-provider-filtering": "",
                    "no-provider-paging": "",
                    "no-provider-sorting": ""
                  },
                  on: {
                    "update:sortBy": function($event) {
                      _vm.sortBy = $event
                    },
                    "update:sort-by": function($event) {
                      _vm.sortBy = $event
                    },
                    "update:sortDesc": function($event) {
                      _vm.sortDesc = $event
                    },
                    "update:sort-desc": function($event) {
                      _vm.sortDesc = $event
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "table-busy",
                        fn: function() {
                          return [
                            _c(
                              "div",
                              { staticClass: "text-center text-success my-2" },
                              [
                                _c("b-spinner", {
                                  staticClass: "align-middle"
                                }),
                                _vm._v(" "),
                                _c("strong", [_vm._v("Загрузка")])
                              ],
                              1
                            )
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "cell(worker_cost_type_id)",
                        fn: function(row) {
                          return [
                            _c("worker-cost-type-select", {
                              ref: "worker_cost_type_select",
                              attrs: {
                                id: "worker-cost-type-select",
                                "is-disabled": _vm.isDisabled,
                                id: row.item.worker_cost_type_id
                              },
                              on: {
                                onSelect: function($event) {
                                  return _vm.onSelectWorkerCostType($event, row)
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(period)",
                        fn: function(row) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "left"
                                }
                              },
                              [
                                _c("b-form-input", {
                                  staticClass: "worker-cost-width",
                                  attrs: {
                                    id: "input_start_date",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    type: "date"
                                  },
                                  model: {
                                    value: row.item.start_date,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "start_date", $$v)
                                    },
                                    expression: "row.item.start_date"
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "mx-1" }, [
                                  _vm._v("-")
                                ]),
                                _vm._v(" "),
                                _c("b-form-input", {
                                  staticClass: "worker-cost-width",
                                  attrs: {
                                    id: "input_end_date",
                                    size: "sm",
                                    disabled: _vm.isDisabled,
                                    type: "date"
                                  },
                                  model: {
                                    value: row.item.end_date,
                                    callback: function($$v) {
                                      _vm.$set(row.item, "end_date", $$v)
                                    },
                                    expression: "row.item.end_date"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(sum)",
                        fn: function(row) {
                          return [
                            _c("b-form-input", {
                              staticClass: "worker-cost-width",
                              attrs: {
                                id: "input_sum",
                                size: "sm",
                                disabled: _vm.isDisabled,
                                autocomplete: "off"
                              },
                              model: {
                                value: row.item.sum,
                                callback: function($$v) {
                                  _vm.$set(row.item, "sum", _vm._n($$v))
                                },
                                expression: "row.item.sum"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "cell(comment)",
                        fn: function(row) {
                          return [
                            _c("b-form-input", {
                              attrs: {
                                id: "input_comment",
                                size: "sm",
                                disabled: _vm.isDisabled,
                                autocomplete: "off"
                              },
                              model: {
                                value: row.item.comment,
                                callback: function($$v) {
                                  _vm.$set(row.item, "comment", $$v)
                                },
                                expression: "row.item.comment"
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "head(action)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-btn",
                              {
                                staticStyle: {
                                  color: "#1A9167 !important",
                                  "text-decoration": "none !important"
                                },
                                attrs: {
                                  variant: "link",
                                  disabled: _vm.isDisabled
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.onAddCost()
                                  }
                                }
                              },
                              [
                                _c("v-icon", {
                                  staticClass: "mr-1",
                                  attrs: { name: "buttons/plus", size: 12 }
                                }),
                                _vm._v("\n            Добавить\n          ")
                              ],
                              1
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(action)",
                        fn: function(row) {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  variant: "link",
                                  disabled: _vm.isDisabled
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.onRemoveCost(row)
                                  }
                                }
                              },
                              [
                                _c("v-icon", {
                                  attrs: { name: "buttons/trash", size: 16 }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1576545743
                  )
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-pagination overflow-visible-context" },
              [
                _c("pagination-footer", {
                  attrs: {
                    "total-rows": _vm.items.length,
                    "per-page": _vm.perPage
                  },
                  on: { "per-page-change": _vm.onPerPageChange }
                })
              ],
              1
            )
          ]
        : _c(
            "div",
            { staticClass: "empty-state-container" },
            [
              _c("v-icon", { attrs: { name: "navbar/empty_table", size: 90 } }),
              _vm._v(" "),
              _c("h5", [_vm._v("Нет добавленных расходов.")]),
              _vm._v(" "),
              _c("p", [_vm._v("Добавьте расходы исполнителя прямо сейчас")]),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  staticClass: "custom-btn-primary mt-1",
                  attrs: { disabled: _vm.isDisabled },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onAddCost()
                    }
                  }
                },
                [
                  _c("v-icon", {
                    staticClass: "mr-1",
                    attrs: { name: "buttons/plus", size: 12 }
                  }),
                  _vm._v("\n      Новый расход\n    ")
                ],
                1
              )
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d0d6dee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d0d6dee","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Workers/WorkerCosts.vue
// module id = null
// module chunks = 